import { IAgentFirmUsers } from '@commenda/types/src/agent-firm-user/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';

type TuseAgentFirmUserOptions = {
  search?: string;
};

export default function useAgentFirmUsers(options?: TuseAgentFirmUserOptions) {
  const query = new URLSearchParams();

  if (options?.search) {
    query.append('search', options.search);
  }

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: {
      data: IAgentFirmUsers[];
    };
    error?: unknown;
    mutate: KeyedMutator<unknown>;
    isLoading: boolean;
  } = useSWR(
    `${API_BASE_PATH}?${query.toString()}`,
    SWRFetcher(
      {
        method: 'GET',
      },
      undefined
    )
  );

  return {
    data: data?.data || [],
    error,
    mutate,
    isLoading,
  };
}
